export const invoiceOrderIds = (invoice: {
  relatedOrderId?: string;
  relatedOrderIds?: string[];
}) =>
  Array.from(
    new Set([
      ...(invoice.relatedOrderIds || []),
      ...(invoice.relatedOrderId ? [invoice.relatedOrderId] : []),
    ]),
  );
